export const GET_ACCOUNT_INTEGRATIONS_V2 = "GET_ACCOUNT_INTEGRATIONS_V2"
export const GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS = "GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS"
export const GET_ACCOUNT_INTEGRATIONS_V2_ERROR = "GET_ACCOUNT_INTEGRATIONS_V2_ERROR"

export const GET_TEMPLATE_INTEGRATIONS_V2 = "GET_TEMPLATE_INTEGRATIONS_V2"
export const GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS = "GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS"
export const GET_TEMPLATE_INTEGRATIONS_V2_ERROR = "GET_TEMPLATE_INTEGRATIONS_V2_ERROR"

export const GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2 = "GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2"
export const GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS = "GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS"
export const GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR = "GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR"

export const GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2 = "GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2"
export const GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS = "GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS"
export const GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR = "GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR"

export const GET_LEAD_INTEGRATION_DETAILS_V2 = "GET_LEAD_INTEGRATION_DETAILS_V2"
export const GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS = "GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS"
export const GET_LEAD_INTEGRATION_DETAILS_V2_ERROR = "GET_LEAD_INTEGRATION_DETAILS_V2_ERROR"

export const DUPLICATE_INTEGRATION_V2 = "DUPLICATE_INTEGRATION_V2"
export const DUPLICATE_INTEGRATION_V2_SUCCESS = "DUPLICATE_INTEGRATION_V2_SUCCESS"
export const DUPLICATE_INTEGRATION_V2_ERROR = "DUPLICATE_INTEGRATION_V2_ERROR"

export const DELETE_INTEGRATION_V2 = "DELETE_INTEGRATION_V2"
export const DELETE_INTEGRATION_V2_SUCCESS = "DELETE_INTEGRATION_V2_SUCCESS"
export const DELETE_INTEGRATION_V2_ERROR = "DELETE_INTEGRATION_V2_ERROR"
